module.exports = __webpack_public_path__ + "img/eye.9a4ce972.svg";